<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-end">
          <mat-chip
            *ngIf="enableVIP && user"
            class="vip-chip mr-2"
            [ngStyle]="{ 'background-color': '#b8870b3a' }"
          >
            <div class="container-icon-chip">
              <mat-icon class="vip-icon">star</mat-icon>
              <span [ngStyle]="{ color: '#b8860b' }"> VIP </span>
            </div>
          </mat-chip>
          <button
            type="button"
            class="gts-btn-primary-outline"
            (click)="openContactsCompany()"
          >
            <span class="gts-btn-text"> Manage HQ POC </span>
          </button>
        </div>
        <hr />
        <!-- <div class="card-header card-header-icon card-header-rose">
        <div class="card-icon">
          <i class="material-icons">perm_identity</i>
        </div>
        <h4 class="card-title">Company's Information</h4>
      </div> -->

        <form #userForm="ngForm" (ngSubmit)="onSubmit()">
          <div class="d-flex justify-content-end">
            <mat-slide-toggle
              [(ngModel)]="isEditCompany"
              (change)="toggleActionCompany($event)"
              class="toggle mb-2"
              >Edit Company Info</mat-slide-toggle
            >
          </div>
          <div class="grid-container mt-4">
            <mat-form-field
              [ngClass]="{
                'has-success': valid.code === 200,
                'has-danger': valid.code !== 200 && valid.code !== null
              }"
            >
              <mat-label> CV CODE </mat-label>
              <input
                disabled
                matInput
                type="text"
                placeholder="{{ valid.msg }}"
                name="companyId"
                [(ngModel)]="user.companyId"
                (change)="validarCompany()"
                maxlength="10"
                required
              />
              <span class="form-control-feedback">
                <i class="material-icons">{{
                  valid.code === 200 ? "done" : "clear"
                }}</i>
              </span>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Company Name</mat-label>
              <input
                matInput
                type="text"
                name="company"
                #company="ngModel"
                [(ngModel)]="user.name"
                required
                [disabled]="!editCompany"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Company Alias</mat-label>
              <input
                matInput
                type="text"
                name="alias"
                #alias="ngModel"
                [(ngModel)]="user.alias"
                [disabled]="!editCompany"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Company Website</mat-label>
              <input
                matInput
                type="text"
                name="website"
                #website="ngModel"
                [(ngModel)]="user.url"
                [disabled]="!editCompany"
              />
            </mat-form-field>
          </div>
          <div class="d-flex justify-content-end">
            <button
              [disabled]="!editCompany"
              type="submit"
              class="gts-btn-primary mr-2"
            >
              <span class="gts-btn-text"> Save Changes </span>
            </button>
            <button
              class="gts-btn-primary-outline"
              type="button"
              (click)="cancelForm('company')"
              *ngIf="editCompany"
            >
              <span class="gts-btn-text"> Cancel </span>
            </button>
          </div>
          <!-- <div class="col-md-6"> -->
          <!-- <mat-form-field
                          class="example-full-width"
                          [ngClass]="{
                            'has-success': valid.code === 200,
                            'has-danger':
                              valid.code !== 200 && valid.code !== null
                          }"
                        >
                          <mat-label>CV Code</mat-label>
                          <input
                            matInput
                            type="text"
                            placeholder="{{ valid.msg }}"
                            name="companyId"
                            #companyId="ngModel"
                            [(ngModel)]="user.companyId"
                            (change)="validarCompany()"
                            maxlength="10"
                            disabled
                          />
                          <span class="form-control-feedback">
                            <i class="material-icons">{{
                              valid.code === 200 ? "done" : "clear"
                            }}</i>
                          </span>
                        </mat-form-field>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-12">
                            <mat-form-field class="example-full-width">
                              <mat-label>Company Name</mat-label>
                              <input
                                matInput
                                type="text"
                                name="company"
                                #company="ngModel"
                                [(ngModel)]="user.name"
                                required
                              />
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-12">
                            <mat-form-field class="example-full-width">
                              <mat-label>Alias</mat-label>
                              <input
                                matInput
                                type="text"
                                name="alias"
                                #alias="ngModel"
                                [(ngModel)]="user.alias"
                              />
                            </mat-form-field>
                          </div>
                        </div>
                      </div> -->

          <div>
            <hr />

            <mat-tab-group style="margin-bottom: 24px" class="mat-typography">
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style="margin-right: 8px">info</mat-icon>
                  HQ Address
                </ng-template>
                <ng-template matTabContent>
                  <div class="mt-4">
                    <div class="d-flex justify-content-end">
                      <mat-slide-toggle
                        (change)="toggleAction($event)"
                        class="toggle mb-2"
                        >Edit HQ Address</mat-slide-toggle
                      >
                    </div>
                    <mat-form-field>
                      <mat-label>Address Line #</mat-label>
                      <input
                        [disabled]="!editAddress"
                        matInput
                        type="text"
                        name="address"
                        #address="ngModel"
                        [(ngModel)]="user.address"
                        required
                      />
                    </mat-form-field>

                    <mat-form-field>
                      <mat-label>Address Line 2 #</mat-label>
                      <input
                        [disabled]="!editAddress"
                        matInput
                        type="text"
                        name="address2"
                        #address2="ngModel"
                        [(ngModel)]="user.address2"
                      />
                    </mat-form-field>
                    <div class="grid-container-3">
                      <mat-form-field class="w-100" *ngIf="!loadingCountries">
                        <mat-label>Country</mat-label>
                        <input
                          [disabled]="!editAddress"
                          type="text"
                          matInput
                          [matAutocomplete]="auto"
                          [formControl]="myControlUserCountries"
                          [matAutocompleteDisabled]="
                            !countries.length || !editAddress
                          "
                          required
                          requireSelection
                        />
                        <mat-autocomplete
                          #auto="matAutocomplete"
                          [displayWith]="displayCountry"
                          (optionSelected)="
                            onCountrySelectedUser($event.option.value)
                          "
                        >
                          <mat-option
                            *ngFor="
                              let country of filteredUserCountries | async
                            "
                            [value]="country"
                          >
                            {{ country.name }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                      <!-- <app-custom-autocomplete
                        class="w-100 mr-3"
                        *ngIf="countries"
                        [options]="formatedCountries"
                        [multiple]="false"
                        [placeholder]="'Country'"
                        [appearance]="'outline'"
                        [disabled]="!editAddress"
                        (selectionChange)="getStates($event)"
                      >
                      </app-custom-autocomplete> -->
                      <!-- <mat-form-field *ngIf="countries.length !== 0">
                        <mat-label>Country</mat-label>
                        <mat-select
                          [disabled]="!editAddress"
                          name="ctry"
                          #ctry="ngModel"
                          [(ngModel)]="user.country"
                          (selectionChange)="getStates(true)"
                          required
                        >
                          <mat-option
                            *ngFor="let country of countries"
                            [value]="country.name"
                          >
                            {{ country.name }} {{country.abbr}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field> -->
                      <mat-form-field *ngIf="states.length === 0">
                        <mat-label class="bmd-label-floating"
                          >State
                          <i
                            *ngIf="loadingStates"
                            class="fa fa-circle-o-notch fa-spin fa-fw"
                          ></i
                        ></mat-label>
                        <input
                          [disabled]="!editAddress"
                          matInput
                          type="text"
                          name="colonia"
                          #colonia="ngModel"
                          [(ngModel)]="user.colonia"
                          required
                        />
                      </mat-form-field>

                      <mat-form-field class="mr-3" *ngIf="states.length !== 0">
                        <mat-label>
                          State
                          <i
                            *ngIf="loadingStates"
                            class="fa fa-circle-o-notch fa-spin fa-fw"
                          ></i>
                        </mat-label>

                        <input
                          type="text"
                          matInput
                          [formControl]="myControlStatesAddress"
                          [matAutocomplete]="auto"
                          [disabled]="!editAddress || loadingStates"
                          required
                          [matAutocompleteDisabled]="
                            !editAddress || loadingStates
                          "
                          requireSelection
                        />

                        <mat-autocomplete
                          #auto="matAutocomplete"
                          (optionSelected)="
                            onStateSelectedAddress($event.option.value)
                          "
                          [displayWith]="displayState"
                        >
                          <mat-option
                            *ngFor="let state of filteredStatesAddress | async"
                            [value]="state"
                          >
                            {{ state.abbr }} - {{ state.name }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>

                      <!-- <mat-form-field *ngIf="states.length > 0">
                        <mat-label>State</mat-label>
                        <mat-select
                          [disabled]="!editAddress || loadingStates"
                          name="colonia"
                          #colonia="ngModel"
                          [(ngModel)]="user.colonia"
                          required
                        >
                          <mat-option
                            *ngFor="let state of states"
                            value="{{ state.abbr }}"
                          >
                            {{ state.abbr }} - {{ state.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field> -->
                      <mat-form-field>
                        <mat-label>City</mat-label>
                        <input
                          [disabled]="!editAddress"
                          matInput
                          type="text"
                          name="city"
                          #city="ngModel"
                          [(ngModel)]="user.city"
                          required
                        />
                      </mat-form-field>

                      <mat-form-field>
                        <mat-label>Zip Code</mat-label>
                        <input
                          [disabled]="!editAddress"
                          matInput
                          type="text"
                          name="zipCode"
                          #zipCode="ngModel"
                          [(ngModel)]="user.zipCode"
                          required
                        />
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Work Phone</mat-label>
                        <input
                          [disabled]="!editAddress"
                          type="text"
                          name="phone"
                          #phone="ngModel"
                          [(ngModel)]="user.phone"
                          matInput
                          required
                        />
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Mobile Phone</mat-label>
                        <input
                          [disabled]="!editAddress"
                          type="text"
                          matInput
                          name="mobilePhone"
                          #mobilePhone="ngModel"
                          [(ngModel)]="user.mobilePhone"
                        />
                      </mat-form-field>
                    </div>
                    <div class="d-flex">
                      <!-- 
                              valid.code !== 200 &&
                          valid.code !== null && -->
                      <button
                        [disabled]="!editAddress"
                        type="submit "
                        class="gts-btn-primary mr-2"
                      >
                        <span class="gts-btn-text"> Save HQ Changes </span>
                      </button>
                      <button
                        class="gts-btn-primary-outline"
                        type="button"
                        (click)="cancelForm('hq')"
                        *ngIf="editAddress"
                      >
                        <span class="gts-btn-text"> Cancel </span>
                      </button>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style="margin-right: 8px">settings</mat-icon>
                  Settings
                </ng-template>
                <ng-template matTabContent>
                  <div class="mt-4">
                    <div class="d-flex justify-content-end">
                      <mat-slide-toggle
                        [(ngModel)]="isEditSettings"
                        (change)="toggleActionSettings($event)"
                        class="toggle"
                        >Edit Settings</mat-slide-toggle
                      >

                      <!-- <mat-checkbox
                        class="check-margin"
                        name="check3rd"
                        [checked]="stateDateCer"
                        (change)="showDate($event)"
                      >
                        R2v3 Certified
                        <mat-label
                          *ngIf="end !== '' || end !== null"
                          class="datelabel"
                        >
                          Expiration date:
                          {{ end !== "NaN-NaN-NaN" || end !== "" ? end : "" }}
                        </mat-label>

                        <mat-label
                          *ngIf="start !== '' || start !== null"
                          class="datelabel"
                        >
                          Initial certification date:
                          {{
                            start !== "NaN-NaN-NaN" || start !== "" ? start : ""
                          }}
                        </mat-label>
                      </mat-checkbox>
                      <i
                        *ngIf="end !== '' || end !== null"
                        (click)="editDate()"
                        class="fa fa-pencil"
                        style="font-size: 18px"
                      ></i> -->
                      <button
                        type="button"
                        (click)="editDate()"
                        class="gts-btn-primary-outline"
                      >
                        <span *ngIf="!end && !start" class="gts-btn-icon-left"
                          >add</span
                        >
                        <span *ngIf="end && start" class="gts-btn-icon-left"
                          >remove_red_eye</span
                        >

                        <span *ngIf="!end && !start" class="gts-btn-text">
                          Add R2 Certification Dates
                        </span>
                        <span *ngIf="end && start" class="gts-btn-text">
                          View R2 Certification Dates
                        </span>
                      </button>
                    </div>
                    <div>
                      <div>
                        <div class="form-group">
                          <mat-checkbox
                            [disabled]="!editSettings"
                            name="check3rd"
                            [(ngModel)]="user.enablePartyPickup"
                            (change)="changePartyPickUp($event)"
                            class="mr-2"
                          >
                            Enable 3rd Party Pickup
                          </mat-checkbox>

                          <mat-checkbox
                            [disabled]="!editSettings"
                            name="checkVIP"
                            [(ngModel)]="user.vipStatus"
                            (change)="changeVIP($event)"
                          >
                            VIP Customer
                          </mat-checkbox>
                        </div>
                      </div>
                      <div>
                        <div class="form-group"></div>
                      </div>
                    </div>

                    <div class="grid-container-3">
                      <mat-form-field>
                        <mat-label>Default Condition</mat-label>
                        <mat-select
                          name="condition"
                          #condition="ngModel"
                          [(ngModel)]="user.conditionId"
                          required
                          [disabled]="!editSettings"
                        >
                          <mat-option
                            *ngFor="let condition of conditions"
                            [value]="condition.id"
                          >
                            {{ condition.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field>
                        <mat-label>Default Currency</mat-label>
                        <mat-select
                          name="currency"
                          #currency="ngModel"
                          [(ngModel)]="user.currenciesId"
                          required
                          [disabled]="!editSettings"
                        >
                          <mat-option
                            *ngFor="let currency of currencies"
                            [value]="currency.id"
                          >
                            {{ currency.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Industry Type</mat-label>
                        <mat-select
                          #industryType="ngModel"
                          name="industryType"
                          [(ngModel)]="industry"
                          placeholder="Industry Type"
                          required
                          [disabled]="!editSettings"
                        >
                          <mat-option value="null">
                            Please select an option
                          </mat-option>
                          <mat-option
                            *ngFor="let type of industryTypes"
                            [value]="type.id"
                          >
                            {{ type.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Default Purchasing Terms</mat-label>
                        <mat-select
                          name="purchasingTerms"
                          #purchasingTerms="ngModel"
                          [(ngModel)]="user.purchasingtermsId"
                          placeholder="Default Purchasing Terms"
                          required
                          [disabled]="!editSettings"
                        >
                          <mat-option
                            *ngFor="let term of purchassingTerms"
                            [value]="term.id"
                          >
                            {{ term.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field>
                        <mat-label>Default Selling Terms</mat-label>
                        <mat-select
                          name="term"
                          #term="ngModel"
                          [(ngModel)]="user.termsId"
                          required
                          [disabled]="!editSettings"
                        >
                          <mat-option
                            *ngFor="let term of terms"
                            [value]="term.id"
                          >
                            {{ term.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <!-- <mat-form-field appearance="fill">
              <mat-label>Default Currency</mat-label>
              <mat-select
                name="currency"
                #currency="ngModel"
                matNativeControl
                [(ngModel)]="user.currenciesId"
                placeholder="Default Currency"
              >
                <mat-option
                  *ngFor="let currency of currencies"
                  [value]="currency.id"
                >
                  {{ currency.name }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
                      <mat-form-field appearance="fill">
                        <mat-label>Default Erasure Method</mat-label>

                        <mat-select
                          name="passDataErasure1"
                          #passDataErasure1="ngModel"
                          [(ngModel)]="user.passDataErasure1"
                          placeholder="Default Erasure Method"
                          required
                          [disabled]="!editSettings"
                        >
                          <mat-option value="null">
                            Please select an option
                          </mat-option>
                          <mat-option
                            *ngFor="let item of erasureMethods"
                            [value]="item.name"
                          >
                            {{ item.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label> Purchasing Credit Limit</mat-label>
                        <input
                          [disabled]="!editSettings"
                          matInput
                          name="purchasingCreditLimit"
                          [(ngModel)]="user.purchasingCreditLimit"
                          type="number"
                          min="0.00"
                          placeholder="0.00"
                        />
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label> Selling Credit Limit</mat-label>
                        <input
                          [disabled]="!editSettings"
                          matInput
                          name="sellingCreditLimit"
                          [(ngModel)]="user.creditLimit"
                          type="number"
                          min="0.00"
                          placeholder="0.00"
                        />
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Outstanding Invoice Day Limit</mat-label>
                        <input
                          [disabled]="!editSettings"
                          matInput
                          type="number"
                          placeholder="0"
                          min="0.00"
                          name="outstandingInvoiceDayLimit"
                          [(ngModel)]="user.outstandingInvoiceDayLimit"
                        />
                      </mat-form-field>
                    </div>

                    <div class="d-flex">
                      <button
                        [disabled]="!editSettings"
                        type="submit "
                        class="gts-btn-primary mr-2"
                      >
                        <span class="gts-btn-text"> Save Settings </span>
                      </button>
                      <button
                        class="gts-btn-primary-outline"
                        type="button"
                        (click)="cancelForm('settings')"
                        *ngIf="editSettings"
                      >
                        <span class="gts-btn-text"> Cancel </span>
                      </button>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style="margin-right: 8px">monetization_on</mat-icon>
                  Taxes
                </ng-template>
                <ng-template matTabContent>
                  <div class="mt-4">
                    <div class="d-flex justify-content-end">
                      <button
                        type="button"
                        class="gts-btn-primary"
                        (click)="openTaxExempt()"
                      >
                        <span class="gts-btn-icon-left">add</span>
                        <span class="gts-btn-text">Add Tax Exemption </span>
                      </button>
                    </div>
                    <dinamic-table
                      [id]="'taxTable'"
                      [dbname]="'taxList'"
                      [frontpaginate]="false"
                      [data]="taxData"
                      [config]="config"
                      [perPage]="itemsPorPaginaTax"
                      [page]="paginaActualTax"
                      [total_items_count]="totalItemTax"
                      [total_pages]="totalPaginasTax"
                      (action_button)="actionTax($event)"
                      (newConfig)="updateConfig($event)"
                      [columnfilters]="filtros"
                      (buscar)="getData($event)"
                    ></dinamic-table>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style="margin-right: 8px"
                    >supervised_user_circle</mat-icon
                  >
                  Users
                </ng-template>
                <ng-template matTabContent>
                  <div>
                    <div>
                      <div class="d-flex justify-content-between mt-4">
                        <app-button-select
                          class=""
                          [options]="optionsButtonSelect"
                          [(selected)]="optionSelectMenuTrigger"
                          (selectedChange)="menuTriggerToShow($event)"
                          [label]="'Status'"
                          [widthPx]="138"
                          [specialWidth]="224"
                        >
                        </app-button-select>
                        <div class="btn-group m-0" role="group">
                          <button
                            id="btnGroupDrop1"
                            type="button"
                            class="gts-btn-primary"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <span class="gts-btn-icon-left">add</span>
                            <span class="gts-btn-text">New User </span>
                          </button>
                          <div
                            class="dropdown-menu w-100"
                            aria-labelledby="btnGroupDrop1"
                          >
                            <button
                              type="button"
                              class="dropdown-item w-100"
                              (click)="newVendor()"
                            >
                              <span class="w-100"> Vendor </span>
                            </button>
                            <button
                              type="button"
                              class="dropdown-item w-100"
                              (click)="openNuevoPaciente()"
                            >
                              <span class=""> Customer </span>
                            </button>
                          </div>
                        </div>

                        <!-- 
                        <button
                          type="button"
                          (click)="openNuevoPaciente()"
                          class="align-self-end gts-btn-primary"
                        >
                          <span class="gts-btn-icon-left">add</span>
                          <span class="gts-btn-text"> New User </span>
                        </button> -->
                      </div>
                      <div *ngIf="cargando" style="text-align: center">
                        <h2>
                          <b
                            ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                            Loading...</b
                          >
                        </h2>
                      </div>
                      <div style="position: relative">
                        <section class="tdbtn2">
                          <div
                            *ngIf="bulkItems.length > 0"
                            style="display: flex"
                          >
                            <div class="title-actions">
                              <b class="gts-btn-text"
                                >{{ bulkItems.length }} Selected:
                              </b>
                            </div>
                            <button
                              class="gts-btn-primary-outline-actions-end"
                              type="button"
                              matTooltip="Remove"
                              (click)="removeBulkStaff()"
                              [disabled]="bulkItems.length === 0"
                            >
                              <span class="gts-btn-icon">delete</span>
                            </button>
                          </div>
                        </section>
                        <!-- <dinamic-table
                          [id]="'taxTable'"
                          [dbname]="'taxList'"
                          [frontpaginate]="false"
                          [data]="taxData"
                          [config]="config"
                          [perPage]="itemsPorPaginaTax"
                          [page]="paginaActualTax"
                          [total_items_count]="totalItemTax"
                          [total_pages]="totalPaginasTax"
                          (action_button)="actionTax($event)"
                          (newConfig)="updateConfig($event)"
                          [columnfilters]="filtros"
                          (buscar)="getData($event)"
                        ></dinamic-table> -->
                        <dinamic-table
                          *ngIf="!cargando"
                          [dbname]="'staffList'"
                          [id]="'staffTable'"
                          [config]="configStaff"
                          (newConfig)="updateConfigStaff($event)"
                          [frontpaginate]="false"
                          [data]="staffData"
                          (action_button)="actions($event)"
                          (buscar)="getData($event)"
                          [perPage]="pageLimit"
                          [page]="page"
                          [total_items_count]="totalItems"
                          [total_pages]="totalPaginas"
                          [columnfilters]="filtrosStaff"
                          [bulk]="bulkItems"
                        ></dinamic-table>
                      </div>
                      <!--               <div class="material-datatables" *ngIf="tableUsers">
                <table
                  id="datatables"
                  class="table table-striped table-no-bordered table-hover"
                  cellspacing="0"
                  width="100%"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th>{{ dataTable.headerRow[1] }}</th>
                      <th>{{ dataTable.headerRow[2] }}</th>
                      <th>{{ dataTable.headerRow[3] }}</th>
                      <th>{{ dataTable.headerRow[4] }}</th>
                      <th>{{ dataTable.headerRow[5] }}</th>
                      <th>{{ dataTable.headerRow[8] }}</th>
                      <th>{{ dataTable.headerRow[9] }}</th>
                      <th class="disabled-sorting text-right">
                        {{ dataTable.headerRow[7] }}
                      </th>
                    </tr>
                  </thead>
                  <tfoot>
                    <tr>
                      <th>{{ dataTable.footerRow[1] }}</th>
                      <th>{{ dataTable.footerRow[2] }}</th>
                      <th>{{ dataTable.footerRow[3] }}</th>
                      <th>{{ dataTable.footerRow[4] }}</th>
                      <th>{{ dataTable.footerRow[5] }}</th>
                      <th>{{ dataTable.footerRow[8] }}</th>
                      <th>{{ dataTable.footerRow[9] }}</th>
                      <th class="text-right">
                        {{ dataTable.footerRow[7] }}
                      </th>
                    </tr>
                  </tfoot>
                  <tbody>
                    <tr
                      id="user{{ row[0] }}"
                      *ngFor="let row of dataTable.dataRows"
                    >
                      <td>{{ row[1] }}</td>
                      <td>{{ row[2] }}</td>
                      <td>{{ row[3] }}</td>
                      <td>{{ row[4] }}</td>
                      <td>{{ row[5] }}</td>
                      <td>{{ row[8] }}</td>
                      <td><button ngClass="{{row[9].activo == 1 ? 'btn-success' : 'gts-btn-secondary ' }}">{{row[9]== 1 ? 'Active' : 'Inactive'}}</button></td>
                      <td class="text-right">
                        <a
                          [routerLink]="['/pages/user', row[0]]"
                          class="btn btn-link btn-info btn-just-icon"
                          ><i class="material-icons">remove_red_eye</i></a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <input
                  type="hidden"
                  name="borrarUser"
                  value=""
                  id="borrarUser"
                />
              </div> -->
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style="margin-right: 8px">location_pin</mat-icon>
                  Locations
                </ng-template>
                <ng-template matTabContent>
                  <!--        Here you can write extra buttons/actions for the toolbar              -->
                  <div class="d-flex justify-content-end mt-4">
                    <button
                      class="gts-btn-primary"
                      type="button"
                      (click)="openNewModal()"
                    >
                      <span class="gts-btn-icon-left">add</span>
                      <span class="gts-btn-text"> New Location </span>
                    </button>
                  </div>
                  <!-- <dinamic-table
                  [id]="'taxTable'"
                  [dbname]="'taxList'"
                  [frontpaginate]="false"
                  [data]="taxData"
                  [config]="config"
                  [perPage]="itemsPorPaginaTax"
                  [page]="paginaActualTax"
                  [total_items_count]="totalItemTax"
                  [total_pages]="totalPaginasTax"
                  (action_button)="actionTax($event)"
                  (newConfig)="updateConfig($event)"
                  [columnfilters]="filtros"
                  (buscar)="getData($event)"
                ></dinamic-table> -->
                  <div style="position: relative">
                    <section class="tdbtn2" *ngIf="bulkItems.length > 0">
                      <div style="display: flex">
                        <div class="title-actions">
                          <b class="gts-btn-text"
                            >{{ bulkItems.length }} Selected:
                          </b>
                        </div>
                        <button
                          class="gts-btn-primary-outline-actions-end"
                          matRipple
                          type="button"
                          matTooltip="Change Location"
                          (click)="removeBulk()"
                          [disabled]="bulkItems.length === 0"
                        >
                          <span class="gts-btn-icon">delete</span>
                        </button>
                      </div>
                    </section>
                    <section style="margin-top: 0px">
                      <dinamic-table
                        [dbname]="'locationsList'"
                        *ngIf="!loadingLocations"
                        [id]="'locationsTable'"
                        [data]="locationsData"
                        (action_button)="actionsLoc($event)"
                        (buscar)="getDataLocations($event)"
                        [frontpaginate]="false"
                        [config]="configLoc"
                        [perPage]="itemsPorPaginaLoc"
                        [page]="paginaActualLoc"
                        [total_items_count]="totalItemLoc"
                        [total_pages]="totalPaginasLoc"
                        (newConfig)="updateConfigLoc($event)"
                        [columnfilters]="filtrosLoc"
                        [bulk]="bulkItems"
                      ></dinamic-table>
                    </section>
                  </div>
                  <!-- [perPage]="pageLimit"
                        [page]="page"
                        [total_items_count]="totalItems"
                        [total_pages]="totalPaginas" -->
                  <!-- <div class="material-datatables">
                    <table
                      id="datatables2"
                      class="table table-striped table-no-bordered table-hover"
                      cellspacing="0"
                      width="100%"
                      style="width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>{{ tableLocations.headerRow[0] }}</th>
                          <th>{{ tableLocations.headerRow[1] }}</th>
                          <th>{{ tableLocations.headerRow[2] }}</th>
                          <th>{{ tableLocations.headerRow[3] }}</th>
                          <th>{{ tableLocations.headerRow[4] }}</th>
                          <th>{{ tableLocations.headerRow[5] }}</th>
                          <th>{{ tableLocations.headerRow[6] }}</th>
                          <th class="disabled-sorting text-right">
                            {{ tableLocations.headerRow[7] }}
                          </th>
                        </tr>
                      </thead>
                      <tfoot>
                        <tr>
                          <th>{{ tableLocations.footerRow[0] }}</th>
                          <th>{{ tableLocations.footerRow[1] }}</th>
                          <th>{{ tableLocations.footerRow[2] }}</th>
                          <th>{{ tableLocations.footerRow[3] }}</th>
                          <th>{{ tableLocations.footerRow[4] }}</th>
                          <th>{{ tableLocations.footerRow[5] }}</th>
                          <th>{{ tableLocations.footerRow[6] }}</th>
                          <th class="text-right">
                            {{ tableLocations.footerRow[7] }}
                          </th>
                        </tr>
                      </tfoot>
                      <tbody>
                        <tr *ngFor="let row of tableLocations.dataRows">
                          <td>{{ row[0] }}</td>
                          <td>{{ row[1] }}</td>
                          <td>{{ row[2] }}</td>
                          <td>{{ row[3] }}</td>
                          <td>{{ row[4] }}</td>
                          <td>{{ row[5] }}</td>
                          <td>{{ row[6] }}</td>
                          <td class="text-right">
                            <a
                              class="btn btn-link btn-info btn-just-icon accion"
                              (click)="openContactsModal(row)"
                              title="Contacts"
                              ><i class="material-icons">people_alt</i></a
                            >
                            <a
                              class="btn btn-link btn-warning btn-just-icon accion"
                              (click)="openNewModal(row[0])"
                              title="Edit"
                              ><i class="material-icons">edit</i></a
                            >
                            <a
                              class="btn btn-link btn-danger btn-just-icon accion"
                              (click)="deleteModal(row[0])"
                              title="Delete"
                              ><i class="material-icons">close</i></a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div> -->
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>

          <!-- <div class="alert alert-success" *ngIf="status_user == 'success'">
            Changes have been saved!
          </div>

          <div class="alert alert-danger" *ngIf="status_user == 'error'">
            Changes have not been saved!
          </div> -->
        </form>

        <div class="card-body">
          <form>
            <div class="clearfix"></div>
          </form>
        </div>
      </div>
    </div>

    <div class="">
      <!-- <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-rose card-header-icon">
                <div class="card-icon">
                  <i class="material-icons">assignment</i>
                </div>
                <h4 class="card-title">3rd Party Pickup</h4>
              </div>
              <div class="col-md-3" style="margin-top: 10px;">
                  <div class="form-group">
                      <mat-checkbox class="check-margin"
                                name="check3rd"
                                [(ngModel)]="user.enablePartyPickup"
                                (change)="changePartyPickUp($event)">
                          <h4 style="margin-top: 10px;"><b>Enable 3rd Party Pickup</b></h4>
                      </mat-checkbox>
                  </div>
              </div>
              <div class="card-body" *ngIf="enable3rd">
                <div class="toolbar" >
                  <div class="row">
                    <div class="col-md-12" style="text-align: right;">
                      <div style="float: right; margin-right: 20px" class="row">
                        <button (click)="openNewModalContactParty()" mat-raised-button class="btn btn-success">
                          <span class="btn-label">
                            <i class="material-icons">person_add</i>
                          </span>
                          Create Contact 3rd Party Pickup
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <app-table-contact-party-pickup *ngIf="!loadingContacts" [id]="'contactPartyPickup'" [elements]="this.contactsPartyPickup" (out)="action($event)"></app-table-contact-party-pickup>

            </div>
          </div>
        </div> -->

      <div class="">
        <div class="">
          <div class="card"></div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="myModal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="exampleModalScrollableTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <div
              class="d-flex flex-column w-100 align-items-center justify-content-center"
            >
              <div class="mt-4">
                <b *ngIf="!isEditLocation" style="font-size: 18px">
                  New Location</b
                >
                <b *ngIf="isEditLocation" style="font-size: 18px">
                  Edit {{ location.name }} Location</b
                >
              </div>
              <mat-chip
                *ngIf="enableDefault && isEditLocation"
                class="vip-chip mr-2"
                [ngStyle]="{ 'background-color': 'rgba(11, 103, 184, 0.23)' }"
              >
                <div class="d-flex align-items-center">
                  <mat-icon class="default-icon mr-2">check_circle</mat-icon>
                  <span [ngStyle]="{ color: 'rgb(11, 87, 184)' }">
                    Default
                  </span>
                </div>
              </mat-chip>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <mat-tab-group style="margin-bottom: 24px" class="mat-typography">
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style="margin-right: 8px">info</mat-icon>
                  Location Info
                </ng-template>
                <ng-template matTabContent> -->
            <form #f="ngForm">
              <mat-checkbox
                name="defaultLocation"
                [(ngModel)]="location.defaultLocation"
                (change)="changeDefaultLocation($event)"
              >
                Default Location
              </mat-checkbox>

              <mat-form-field class="form-group">
                <mat-label>Name Location</mat-label>
                <input
                  type="text"
                  matInput
                  name="name"
                  #name="ngModel"
                  [(ngModel)]="location.name"
                  required
                />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Address Line #</mat-label>
                <input
                  type="text"
                  matInput
                  name="address"
                  #address="ngModel"
                  [(ngModel)]="location.address"
                  required
                />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Address Line 2 #</mat-label>
                <input
                  type="text"
                  matInput
                  name="address2"
                  #address2="ngModel"
                  [(ngModel)]="location.address2"
                />
              </mat-form-field>
              <div class="d-flex">
                <mat-form-field class="w-100 mr-3">
                  <mat-label>Country</mat-label>
                  <input
                    type="text"
                    matInput
                    [matAutocomplete]="auto"
                    [formControl]="myControlCountries"
                    [matAutocompleteDisabled]="!countries.length"
                    required
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    [displayWith]="displayCountry"
                    (optionSelected)="onCountrySelected($event.option.value)"
                  >
                    <mat-option
                      *ngFor="let country of filteredCountries | async"
                      [value]="country"
                    >
                      {{ country.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <!-- <app-custom-autocomplete
                  class="w-100 mr-3"
                  *ngIf="
                    countries && !loadinglocation && formatedCountriesLocation
                  "
                  [options]="formatedCountriesLocation"
                  [multiple]="false"
                  [placeholder]="'Country'"
                  [appearance]="'outline'"
                  (selectionChange)="setLocation($event)"
                >
                </app-custom-autocomplete> -->
                <!-- {{ location.country }} -->

                <!-- <mat-form-field class="mr-3">
                        <mat-label>Country</mat-label>
                        <mat-select
                          required
                          name="country"
                          #country="ngModel"
                          [(ngModel)]="location.country"
                          (selectionChange)="getStates(true, 'location', $event)"
                        >
                          <mat-option
                            *ngFor="let country of countries"
                            [value]="country.name"
                          >
                           {{  formatName(country.name)}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field> -->
                <!-- {{location.colonia}}
      {{states.length}} -->
                <!-- {{ location.colonia }} - {{ location.state }} aqui -->
                <mat-form-field class="mr-3" *ngIf="states.length !== 0">
                  <mat-label>
                    State
                    <i
                      *ngIf="loadingStates"
                      class="fa fa-circle-o-notch fa-spin fa-fw"
                    ></i>
                  </mat-label>

                  <input
                    type="text"
                    matInput
                    [formControl]="myControlStates"
                    [matAutocomplete]="auto"
                    [disabled]="loadingStates"
                    required
                  />

                  <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="onStateSelected($event.option.value)"
                    [displayWith]="displayState"
                  >
                    <mat-option
                      *ngFor="let state of filteredStates | async"
                      [value]="state"
                    >
                      {{ state.abbr }} - {{ state.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <!-- <mat-form-field class="mr-3" *ngIf="states.length !== 0">
                  <mat-label
                    >State
                    <i
                      *ngIf="loadingStates"
                      class="fa fa-circle-o-notch fa-spin fa-fw"
                    ></i
                  ></mat-label>
                  <mat-select
                    required
                    name="state"
                    #state="ngModel"
                    [(ngModel)]="location.colonia"
                    [disabled]="loadingStates"
                  >
                    <mat-option
                      *ngFor="let state of states"
                      value="{{ state.abbr }}"
                    >
                      {{ state.abbr }} - {{ state.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
                <mat-form-field class="mr-3" *ngIf="states.length === 0">
                  <mat-label
                    >State
                    <i
                      *ngIf="loadingStates"
                      class="fa fa-circle-o-notch fa-spin fa-fw"
                    ></i
                  ></mat-label>
                  <input
                    required
                    matInput
                    type="text"
                    name="stateName"
                    #state="ngModel"
                    [(ngModel)]="location.state"
                    [disabled]="loadingStates"
                  />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>City</mat-label>
                  <input
                    matInput
                    type="text"
                    name="city"
                    #city="ngModel"
                    [(ngModel)]="location.city"
                    required
                  />
                </mat-form-field>
              </div>
              <mat-form-field>
                <mat-label>Zip Code</mat-label>
                <input
                  matInput
                  type="text"
                  name="zipCode"
                  #zipCode="ngModel"
                  [(ngModel)]="location.zipCode"
                  required
                />
              </mat-form-field>
              <hr />
              <!-- <button
                      *ngIf="!isEditLocation"
                      type="button"
                      class="gts-btn-primary-outline"
                      (click)="showContactForm = !showContactForm"
                    >
                      <span *ngIf="!showContactForm" class="gts-btn-icon"> add </span>
                      <span *ngIf="showContactForm" class="gts-btn-icon">
                        remove
                      </span>
                      <span class="gts-btn-text"> Add Contact to Location </span>
                    </button> -->
              <div class="mt-4" *ngIf="showContactForm">
                <!-- <mat-form-field class="mr-3">
                        <mat-label>Contact Name</mat-label>
                        <input
                          type="text"
                          matInput
                          name="contactName"
                          #contactName="ngModel"
                          [(ngModel)]="location.contactName"
                        />
                      </mat-form-field> -->

                <!-- <div class="d-flex">
                        <mat-form-field class="mr-3">
                          <mat-label>Email</mat-label>
                          <input
                            type="text"
                            matInput
                            name="email"
                            #email="ngModel"
                            [(ngModel)]="location.email"
                          />
                          <label
                            *ngIf="email.touched && !validateEmail(location.email)"
                            style="color: red"
                            >The email is not valid</label
                          >
                        </mat-form-field>
                        <mat-form-field class="mr-3">
                          <mat-label>Work Phone</mat-label>
                          <input
                            [required]="showContactForm"
                            type="text"
                            matInput
                            name="phone"
                            #phone="ngModel"
                            [(ngModel)]="location.phone"
                          />
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>Mobile Phone</mat-label>
                          <input
                            type="text"
                            matInput
                            name="mobilePhone"
                            #mobilePhone="ngModel"
                            [(ngModel)]="location.mobilePhone"
                          />
                        </mat-form-field>
                      </div> -->
                <app-multi-files
                  *ngIf="!loadinglocation && isEditLocation"
                  title="Resale Tax Certificate:"
                  [idfather]="location.id"
                  [type]="'ResaleTaxCertificateLocation'"
                ></app-multi-files>
              </div>
              <div class="modal-footer" style="text-align: center">
                <button
                  *ngIf="!isEditLocation"
                  type="button"
                  class="gts-btn-primary"
                  (click)="newLocation()"
                  [disabled]="
                    !f.valid ||
                    (showContactForm && !validateEmail(location.email))
                  "
                >
                  <span class="gts-btn-text"> Create Location </span>
                </button>
                <button
                  *ngIf="isEditLocation"
                  type="button"
                  class="gts-btn-primary"
                  (click)="editLocation()"
                  [disabled]="!f.valid"
                >
                  <span class="gts-btn-text">Save Changes</span>
                </button>
              </div>
            </form>
            <!-- </ng-template>
              </mat-tab> -->
            <!-- <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon style="margin-right: 8px">people_alt</mat-icon>
                  Contacts
                </ng-template>
                <ng-template matTabContent>
                  <form action="">
                    <mat-form-field class="mr-3">
                      <mat-label>Contact Name</mat-label>
                      <input
                        type="text"
                        matInput
                        name="contactName"
                        #contactName="ngModel"
                        [(ngModel)]="location.contactName"
                      />
                    </mat-form-field>

                    <div class="d-flex">
                      <mat-form-field class="mr-3">
                        <mat-label>Email</mat-label>
                        <input
                          type="text"
                          matInput
                          name="email"
                          #email="ngModel"
                          [(ngModel)]="location.email"
                        />
                        <label
                          *ngIf="
                            email.touched && !validateEmail(location.email)
                          "
                          style="color: red"
                          >The email is not valid</label
                        >
                      </mat-form-field>
                      <mat-form-field class="mr-3">
                        <mat-label>Work Phone</mat-label>
                        <input
                          [required]="showContactForm"
                          type="text"
                          matInput
                          name="phone"
                          #phone="ngModel"
                          [(ngModel)]="location.phone"
                        />
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Mobile Phone</mat-label>
                        <input
                          type="text"
                          matInput
                          name="mobilePhone"
                          #mobilePhone="ngModel"
                          [(ngModel)]="location.mobilePhone"
                        />
                      </mat-form-field>
                    </div>
                  </form>
                </ng-template>
              </mat-tab> -->
            <!-- </mat-tab-group> -->
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="editModal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="exampleModalScrollableTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalScrollableTitle">
              <b>Edit Location</b>
            </h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form #f2="ngForm">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating">Name Location</label>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      #name="ngModel"
                      [(ngModel)]="location.name"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating">Contact Name</label>
                    <input
                      type="text"
                      class="form-control"
                      name="contactName"
                      #contactName="ngModel"
                      [(ngModel)]="location.contactName"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating">Email</label>
                    <input
                      type="text"
                      class="form-control"
                      name="email"
                      #email2="ngModel"
                      [(ngModel)]="location.email"
                    />
                    <label
                      *ngIf="email2.touched && !validateEmail(location.email)"
                      style="color: red"
                      >The email is not valid</label
                    >
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating">Work Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      name="phone"
                      #phone="ngModel"
                      [(ngModel)]="location.phone"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating">Mobile Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      name="mobilePhone"
                      #mobilePhone="ngModel"
                      [(ngModel)]="location.mobilePhone"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating">Address Line #</label>
                    <input
                      type="text"
                      class="form-control"
                      name="address"
                      #address="ngModel"
                      [(ngModel)]="location.address"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating">Address Line 2 #</label>
                    <input
                      type="text"
                      class="form-control"
                      name="address2"
                      #address2="ngModel"
                      [(ngModel)]="location.address2"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating">City</label>
                    <input
                      type="text"
                      class="form-control"
                      name="city"
                      #city="ngModel"
                      [(ngModel)]="location.city"
                      required
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div *ngIf="states2.length !== 0" class="form-group">
                    <label class="bmd-label-floating"
                      >State
                      <i
                        *ngIf="loadingStates2"
                        class="fa fa-circle-o-notch fa-spin fa-fw"
                      ></i
                    ></label>
                    <select
                      name="state"
                      #state="ngModel"
                      [(ngModel)]="location.colonia"
                      [disabled]="loadingStates2"
                      class="form-control fctrl"
                    >
                      <option
                        *ngFor="let state of states2"
                        value="{{ state.abbr }}"
                      >
                        {{ state.abbr }} - {{ state.name }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="states2.length === 0" class="form-group">
                    <label class="bmd-label-floating"
                      >State
                      <i
                        *ngIf="loadingStates2"
                        class="fa fa-circle-o-notch fa-spin fa-fw"
                      ></i
                    ></label>
                    <input
                      type="text"
                      name="stateName"
                      #state="ngModel"
                      [(ngModel)]="location.state"
                      [disabled]="loadingStates2"
                      class="form-control fctrl"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating">Country</label>
                    <select
                      name="country"
                      #country="ngModel"
                      [(ngModel)]="location.country"
                      (change)="getStates($event)"
                      class="form-control fctrl"
                    >
                      <option
                        *ngFor="let country of countries"
                        [value]="country.value"
                      >
                        {{ country.value }} - {{ country.name }} -
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating">Zip Code</label>
                    <input
                      type="text"
                      class="form-control"
                      name="zipCode"
                      #zipCode="ngModel"
                      [(ngModel)]="location.zipCode"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <app-multi-files
                    *ngIf="!loadinglocation"
                    title="Resale Tax Certificate:"
                    [idfather]="location.id"
                    [type]="'ResaleTaxCertificateLocation'"
                  ></app-multi-files>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer" style="text-align: center">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              Close
            </button>
            &nbsp;&nbsp;
            <button
              type="button"
              class="btn btn-success"
              (click)="editLocation()"
              [disabled]="!f2.valid || !validateEmail(location.email)"
            >
              Edit Location
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modalDelete"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="exampleModalScrollableTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalScrollableTitle">
              <b>Are you sure to delete this location?</b>
            </h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-footer">
            <button type="button" class="gts-btn-primary" data-dismiss="modal">
              <span class="gts-btn-text"> Cancel </span>
            </button>
            &nbsp;&nbsp;
            <button
              type="button"
              class="gts-btn-primary-outline"
              (click)="deleteLocation()"
            >
              <span class="gts-btn-text"> Delete </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="myModalContactPickup"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="exampleModalScrollableTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalScrollableTitle">
              <b *ngIf="showContactPickup">Show Contact</b>
              <b *ngIf="newContactPickup">New Contact</b>
              <b *ngIf="editContactPickup">Edit Contact</b>
            </h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form #fContact="ngForm">
              <div class="row">
                <div class="col-12">
                  <mat-form-field>
                    <input
                      type="text"
                      name="name"
                      [(ngModel)]="nameContactPickup"
                      matInput
                      placeholder="Name"
                      [disabled]="showContactPickup"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <mat-form-field>
                    <input
                      type="text"
                      name="email"
                      [(ngModel)]="emailContactPickup"
                      matInput
                      placeholder="Email"
                      [disabled]="showContactPickup"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <mat-form-field>
                    <input
                      type="text"
                      name="phone"
                      [(ngModel)]="phoneContactPickup"
                      matInput
                      placeholder="Phone"
                      [disabled]="showContactPickup"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              Close
            </button>
            &nbsp;&nbsp;
            <button
              *ngIf="newContactPickup"
              type="button"
              class="btn btn-primary"
              (click)="addContactPickup()"
              [disabled]="!fContact.valid || saving"
            >
              <i *ngIf="saving" class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
              Save changes
            </button>
            <button
              *ngIf="editContactPickup"
              type="button"
              class="btn btn-primary"
              (click)="editContactPickupFunction()"
              [disabled]="!fContact.valid || saving"
            >
              <i *ngIf="saving" class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modalDeleteContact"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="exampleModalScrollableTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalScrollableTitle">
              <b>Are you sure to delete this contact?</b>
            </h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-dismiss="modal">
              Cancel
            </button>
            &nbsp;&nbsp;
            <button
              type="button"
              class="btn btn-danger"
              (click)="deleteContactPickup()"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="modalCertified" class="modal fade" data-keyboard="false">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div *ngIf="stateCert" class="container">
          <loading></loading>
        </div>

        <div *ngIf="!stateCert">
          <!-- Modal Header -->
          <div class="modal-header text-center">
            <h2 class="modal-title" style="font-size: 18px">
              R2 Certification Dates
            </h2>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <div>
              <div class="d-flex align-items-center">
                <mat-form-field class="mr-3">
                  <mat-label for="startDate" class="form-label"
                    >Initial certification date</mat-label
                  >
                  <div class="input-group">
                    <input
                      type="date"
                      id="startDate"
                      class="form-control"
                      [(ngModel)]="startDate"
                      matInput
                    />
                  </div>
                </mat-form-field>
                <button
                  (click)="chDate('', 1)"
                  class="gts-btn-primary-outline"
                  *ngIf="stateDate"
                >
                  <span class="gts-btn-icon-left"> close </span>

                  <span class="gts-btn-text"> Clear </span>
                </button>
              </div>

              <!-- <div class="modal-header text-center">
                <h2 class="modal-title" style="font-size: 18px">
                  Expiration Date
                </h2>
              </div> -->
              <div class="d-flex align-items-center">
                <mat-form-field class="mr-3">
                  <mat-label for="expirationDate"> Expiration Date</mat-label>
                  <input
                    type="date"
                    id="expirationDate"
                    class="form-control"
                    [(ngModel)]="endDate"
                    matInput
                  />
                </mat-form-field>
                <button
                  class="gts-btn-primary-outline"
                  (click)="chDate('', 2)"
                  *ngIf="stateDate"
                >
                  <span class="gts-btn-icon-left"> close </span>
                  <span class="gts-btn-text"> Clear </span>
                </button>
              </div>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer justify-content-end">
            <button
              type="button"
              (click)="closeModal()"
              class="gts-btn-primary-outline mr-3"
            >
              <span class="gts-btn-text"> Cancel </span>
            </button>
            <button type="button" class="gts-btn-primary" (click)="dateCert()">
              <span class="gts-btn-text"> Save date </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="myModalTax"
    tabindex="-1"
    role="dialog"
    data-backdrop="static"
    aria-labelledby="exampleModalScrollableTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3
            style="font-size: 18px"
            class="modal-title"
            id="exampleModalScrollableTitle"
          >
            <b *ngIf="!editTax">Add Tax Excemption</b>
            <b *ngIf="editTax">Edit Tax Excemption</b>
          </h3>
          <button
            (click)="closeTax()"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="!editTax" class="card-body">
          <mat-stepper [linear]="true">
            <mat-step
              [completed]="state_id && taxNumber"
              label="Tax Information"
            >
              <mat-form-field class="mr-3" *ngIf="statesTax?.length > 0">
                <mat-label>For Which State?</mat-label>
                <mat-select
                  name="state"
                  #state="ngModel"
                  [(ngModel)]="state_id"
                  required
                >
                  <mat-option
                    *ngFor="let state of statesTax"
                    [value]="state.id"
                  >
                    {{ state.abbr }} - {{ state.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Tax Exempt Registration Number</mat-label>
                <input
                  matInput
                  type="text"
                  name="taxNumber"
                  [(ngModel)]="taxNumber"
                  required
                />
              </mat-form-field>
              <button
                class="gts-btn-primary-outline"
                matRipple
                (click)="createTaxExempt()"
                [disabled]="!taxNumber || !state_id || loadingSave"
              >
                <span class="gts-btn-icon-left">east</span
                ><span class="gts-btn-text">Next</span>
              </button>
            </mat-step>
            <mat-step label="Resale Tax Certificate">
              <app-multi-files
                *ngIf="showMultiFiles"
                [fileUrl]="fileURL"
                [idfather]="taxId"
                [type]="'ResaleTaxCertificateCompany'"
                (fileUrlChange)="fileURL = $event"
                [disabled]="disableFiles"
                (total)="onTotalChanged($event)"
              ></app-multi-files>
              <button
                class="gts-btn-primary"
                matRipple
                (click)="saveEditTax()"
                [disabled]="!taxNumber || !state_id || !fileURL || loadingSave"
              >
                <span class="gts-btn-text">Save</span>
              </button>
            </mat-step>
          </mat-stepper>
        </div>
        <div *ngIf="editTax" class="card-body">
          <div class="">
            <mat-form-field class="mr-3" *ngIf="statesTax?.length > 0">
              <mat-label>For Which State?</mat-label>
              <mat-select
                name="state"
                #state="ngModel"
                [(ngModel)]="state_id"
                required
              >
                <mat-option *ngFor="let state of statesTax" [value]="state.id">
                  {{ state.abbr }} - {{ state.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Tax Exempt Registration Number</mat-label>
              <input
                matInput
                type="text"
                name="taxNumber"
                [(ngModel)]="taxNumber"
                required
              />
            </mat-form-field>
          </div>
          <!-- [idfather]="fileURL ? fileURL.id : user.id" -->
          <app-multi-files
            *ngIf="taxId && showMultiFiles"
            [idfather]="taxId"
            [type]="'ResaleTaxCertificateCompany'"
            [disabled]="disableFiles"
            title="Upload Resale Tax Certificate (1 file ONLY)"
            (total)="onTotalChanged($event)"
          ></app-multi-files>

          <button
            *ngIf="editTax"
            [disabled]="!state_id || !taxNumber || disableFiles == false"
            type="button"
            class="gts-btn-primary mt-4"
            (click)="saveEditTax()"
          >
            <span class="gts-btn-text"> Save </span>
          </button>
          <!-- <button
              *ngIf="!editTax"
              [disabled]="!fileURL || !state_id || !taxNumber"
              type="button"
              class="gts-btn-primary mt-4"
              (click)="createTaxExempt()"
            >
              <span class="gts-btn-text"> Save Tax Exempt </span>
            </button> -->
        </div>
      </div>
    </div>
  </div>
</div>
